export const environment = {
  production: true,
  youtube: {
    API_KEY: 'AIzaSyD35t4EiSMoYWtyuxzUGhcZ0gct0ZBqrdo',
    CLIENT_ID: '384399550442-edth09t6n3uu2qqdcp1h26munnsdot0r.apps.googleusercontent.com',
    TOTAL_API_RESULTS: '20'
  }
};
